import "./CloudStrategyTransformation.module.css";
import EnTete from "@/reusable_sections/Header";
import HeroDuService from "./sections/HeroDuService";
import ServiceDetailsSection from "./sections/ServiceDetailsSection";
import AppelAction from "./sections/AppelAction";
import Footer from "@/reusable_sections/Footer";
export default function CloudStrategyTransformationPage() {
  return <div>
      <EnTete />
      <HeroDuService />
      <ServiceDetailsSection />
      <AppelAction />
      <Footer />
    </div>;
}